import { Badge, type BadgeProps } from '@mantine/core'
import { customerCategoryColor } from './colors'

interface Props extends Omit<BadgeProps, 'color'> {
  category: string
}

export function KindBadge({ category, variant = 'light', size = 'xs', ...rest }: Props) {
  const color = customerCategoryColor[category] ?? 'gray'
  return (
    <Badge color={color} variant={variant} size={size} radius="sm" {...rest}>
      {category}
    </Badge>
  )
}
